<ng-container>
  @if (frequency) {
    <span> {{ frequency }} </span>
  } @else {
    -
  }
</ng-container>
